export default __webpack_public_path__ + "static/media/brico_prive-logo.7d8306fb.png";